import { readRemaininghtnrfi4c8vp0 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_save__qhzefp(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var tmp = readRemaining(_this__u8e3s4.q5g().b5j(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var responseBody = readByteArray(tmp);
  return SavedHttpCall().k5k(_this__u8e3s4.l5g_1, _this__u8e3s4.m5i(), _this__u8e3s4.q5g(), responseBody);
}
function save(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, _this__u8e3s4), $completion);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static k5k(client, request, response, responseBody) {
        var $this = this.l5i(client);
        $this.i5k_1 = responseBody;
        $this.n5g_1 = new (SavedHttpRequest())($this, request);
        $this.o5g_1 = new (SavedHttpResponse())($this, $this.i5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.i5k_1.length), request.u5i());
        $this.j5k_1 = true;
        return $this;
      }
      o5i() {
        return this.j5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.l5k_1 = origin;
        this.m5k_1 = call;
      }
      t5i() {
        return this.m5k_1;
      }
      ew() {
        return this.l5k_1.ew();
      }
      u5i() {
        return this.l5k_1.u5i();
      }
      v5i() {
        return this.l5k_1.v5i();
      }
      n5i() {
        return this.l5k_1.n5i();
      }
      t2o() {
        return this.l5k_1.t2o();
      }
      n50() {
        return this.l5k_1.n50();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.n5k_1 = call;
        this.o5k_1 = body;
        this.p5k_1 = origin.c5j();
        this.q5k_1 = origin.d5j();
        this.r5k_1 = origin.e5j();
        this.s5k_1 = origin.f5j();
        this.t5k_1 = origin.n50();
        this.u5k_1 = origin.ew();
      }
      t5i() {
        return this.n5k_1;
      }
      c5j() {
        return this.p5k_1;
      }
      d5j() {
        return this.q5k_1;
      }
      e5j() {
        return this.r5k_1;
      }
      f5j() {
        return this.s5k_1;
      }
      n50() {
        return this.t5k_1;
      }
      ew() {
        return this.u5k_1;
      }
      b5j() {
        return ByteReadChannel(this.o5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save2n0hem2ixzltm,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
